@for (toast of toasts(); track toast.id) {
  <esn-toast
    [message]="toast.message"
    [actionLabel]="toast.actionLabel"
    [tone]="toast.tone"
    (action)="service.runAction(toast.id)"
    (dismissed)="service.dismiss(toast.id)"
  />
}
